import { action } from "mobx";
import AwsS3MultipartUploadRepository from "~/repository/AwsS3/AwsS3MultipartUploadRepository";

class AwsS3MultipartUploadStore {
  /**
   * @property {AwsS3MultipartUploadRepository|null}
   */
  awsS3MultipartUploadRepository = null;

  constructor() {
    this.awsS3MultipartUploadRepository = new AwsS3MultipartUploadRepository();
  }

  @action
  create(data) {
    return this.awsS3MultipartUploadRepository.create(data);
  }

  @action
  update(data) {
    return this.awsS3MultipartUploadRepository.update(data);
  }

  @action
  delete(uploadId, key) {
    return this.awsS3MultipartUploadRepository.delete(uploadId, key);
  }
}

export default AwsS3MultipartUploadStore;
